import { Button, Text } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { filteredRatesEmptyStateMessages } from './filtered-rates-empty-state-messages';
import styles from './FilteredRatesEmptyState.module.css';

type FilteredRatesEmptyStateProps = {
  onClearFilters: () => void;
};

export const FilteredRatesEmptyState = ({ onClearFilters }: FilteredRatesEmptyStateProps) => (
  <div className={styles.container} data-testid='filtered-rates-empty'>
    <Text className={styles.title} component='div'>
      <FormattedMessage {...filteredRatesEmptyStateMessages.title} />
    </Text>
    <Text className={styles.subtitle} component='div'>
      <FormattedMessage {...filteredRatesEmptyStateMessages.subtitle} />
    </Text>
    <Button data-testid='filtered-rates-clear' onClick={onClearFilters} variant='hyperlink'>
      <FormattedMessage {...filteredRatesEmptyStateMessages.clearSelection} />
    </Button>
  </div>
);
